import { ForexDraftState } from "@/feature/Forex/store/draft/interface";

export default <ForexDraftState> {
	list: [],
	loadingCount: 0,
	isEndPage: false,
	pageSize: 25,
	pageNumber: 1,
	operationType: null,
	currency: null,
	dateFrom: '',
	dateTo: ''
}